const config = Object.assign({}, window.SIMPLEFORM_APP);

export function getNonce() {
	return config.nonce;
}

export function getAjaxUrl() {
	return config.admin_ajax || window.ajaxurl || '/wp-admin/admin-ajax.php';
}

export function isPro() {
	return config.isPro;
}


export function turnsTile() {
	return config.turnsTile;
}

export function getTables() {
	return config.tables;
}

export function getFormSettings() {
	return config.formsettings;
}

// Default setting once table create.
export function getDefaultSettings() {
	return {	
		floatingwidgets: false,
		mailNotification: false,
		openInNewTab: false,
		recipientMail: "",
		selectedTable: "",
	};
}